import { LinkingListType } from "../../services/types";
import { OrganizationAppsLinkingPage } from "../components/LinkList";

export const OrganizationAppsLinkingContactPage = () => {
	return <OrganizationAppsLinkingPage listType={LinkingListType.CONTACT} />;
};
